import { ActionGroupTypes, ActionStatusTypes } from "../../../enum/ActionStatusTypes";
import * as logger from "../../../logger";
import * as nodeUtils from "../../../utils/nodeUtils";
import * as systemUtils from "../../../utils/systemUtils";
import { ACTION_PREFIX_FUNCTION } from "./abstract/functionAbstract";

const _action = `${ACTION_PREFIX_FUNCTION}_create`;
const _header = `Create function`;

export const addFunction = (root, body) => {
  const _payload = addFunctionLogic(root, body);

  logger.logAction(_action, _payload, ACTION_PREFIX_FUNCTION);

  return { root, info: _payload };
};

//--------------------------------------------------------------------------------

export const addFunctionLogic = (root, body) => {
  if (!body) {
    throw new Error("Function to add not found");
  }
  const _index = nodeUtils.getFunctions(root).length;

  nodeUtils.modifyFunctions(root, (e) => e.push(body), false);

  return generatePayload(body, _index);
};

//-------------------------------------------------------------------------------

const generatePayload = (body, index) => {
  const _payload = {
    group: ActionGroupTypes.ADD,
    status: ActionStatusTypes.INDIFFERENT,
    action: _action,
    time: systemUtils.getTimestamp(),
    header: _header,
    description: generatePayloadDescription(),
    node: systemUtils.createDeepCopy(body),
    uuid: nodeUtils.getUUID(body),
    index: index,
  };

  return _payload;
};

const generatePayloadDescription = () => {

    return `Add a new function.`;
}